<div>
    <div class="flex jc-c mapfre-mt-s">
        <img width="50" src="assets/icons/info.svg" alt="">
    </div>
    <div class="dark mapfre-fs-xs text-center mapfre-mt-sm">
        {{ 'INFO_MODAL.TEXT' | translate }}
    </div>
    <div class="mapfre-mt-sm">
        <app-button (click)="onContinue()" type="dark" [text]="'Entendido'">
        </app-button>
    </div>
</div>